// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"8b57f602","210":"f0d7807a","262":"c342e2a8","332":"c342e2a8","464":"c342e2a8","533":"9b8b49f5","879":"c342e2a8"}[chunkId] + ".chunk.css";
};